import './types';

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {RequestDetails} payload - Action payload.
 */
export const removeStatsLeadersRequest = ( draft, payload ) => {
    draft.requests = draft.requests.filter( x => !_.isEqual( x, payload ) );
};